import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Divider, Button, Input, Form, TimePicker
} from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';

import styles from './GenericWrapperAction.module.less';

import moment from 'moment';

const format = 'HH:mm';

function GenericWrapperAction(props) {

  const {
    inputType,
    index,
    action,
    actionTarget: target,
    addItem,
    onChangeItem,
    onChangeItemTime,
    removeItem,
  } = props;
  const { t } = useTranslation();

  const placeholder = (function () {

    switch (inputType) {

      case 'url':
        return t('views.dynamic_alarms_create_edit.placeholders.url');
      case 'email':
        return t('common.email'); 
      default:
        return '';

    }

  }());

  return (
    <>
      <Divider />
      <div className={styles.items_wrapper}>

        {action.params && inputType === 'report' && ( 
            <TimePicker 
              value={action.params.time ? moment(action.params.time, format) : null}
              onChange={(value) => {
                if (value !== null) { 
                  onChangeItemTime(index,moment(value).format(format))
                } else {
                  onChangeItemTime(index,'')
                }
              }}
              format={format}
            /> 
          )
        }

        {action.params[target]
          && action.params[target].map((url, indexUrl) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`url_${indexUrl}`} className={styles.item}>
              <Button
                disabled={action.params[target] && action.params[target].length === 1}
                className={styles.remove_item}
                shape="circle"
                size="small"
                type="text"
                onClick={() => removeItem(index, indexUrl)}
              >
                <FontAwesomeIcon icon={faMinusCircle} />
              </Button>
              <Input
                rules={[
                  { required: true, message: t('forms.users.rules.email') },
                  { type: 'email', message: t('forms.users.rules.type_email') },
                ]}
                type="email"
                className={styles.input_new_item}
                placeholder={placeholder}
                value={url}
                // type={inputType}
                onChange={(e) => onChangeItem(index, indexUrl, e.target.value)}
              />
            </div>
          ))}
      </div>
      <Divider />
      <Button className={styles.add_item} type="dashed" onClick={() => addItem(index)}>
        {(function () {

          switch (inputType) {

            case 'url':
              return t('views.dynamic_alarms_create_edit.buttons.add_url');
            case 'report':
            case 'email':
              return t('views.dynamic_alarms_create_edit.buttons.add_email'); 
            default:
              return '-';

          }

        }())}
      </Button>
    </>
  );

}

GenericWrapperAction.propTypes = {
  inputType: PropTypes.oneOf(['url', 'email', 'report']).isRequired,
  action: PropTypes.objectOf(PropTypes.any).isRequired,
  actionTarget: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  removeItem: PropTypes.func.isRequired,
  onChangeItem: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
};

GenericWrapperAction.defaultProps = {};

export default GenericWrapperAction;
